export default __webpack_public_path__ + "static/media/main-swiper-1.c3d1cee9.png";